import "./PTPS.less";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";
import { Icon } from "../../shared/Icon";
import {
  label,
  // logger
} from "../../../framework";
import {
  navigateAction,
  routeToPageNotFoundAction,
} from "../../../redux/actions";
import { Header, Footer, Banner } from "../EWCMS/Layout";
import HeaderBar from "./HeaderBar";
import MainMenu from "./MainMenu";
import Appointment from "../Appointment";
import { HourlyPage } from "../RequestPage";
import { ApproveRequest, EndorserRequest } from "../Approve";
import MonthlyPage from "../RequestPage/MonthlyPage";
import LumpSumPage from "../RequestPage/LumpSumPage";
import ImportantNotesPage from "../ImportantNotesPage/ImportantNotesPage";
import SuspendPage from "../SuspendPage/SuspendPage";
import AccountPage from "../Account/AccountPage";

function PTPS(props) {
  const { loading, currPageFunction, screenSize, component, device, navigate } =
    props;

  // const [currWidthOption, setcurrWidthOption] = useState("container-best");
  // const [currBannerOption, setcurrBannerOption] = useState("default");
  const currWidthOption = "container-best";
  const currBannerOption = "default";

  const components = {
    Appointment: <Appointment />,
    HourlyPage: <HourlyPage />,
    ApproveRequest: <ApproveRequest />,
    EndorserRequest: <EndorserRequest />,
    MonthlyPage: <MonthlyPage />,
    LumpSumPage: <LumpSumPage />,
    ImportantNotesPage: <ImportantNotesPage />,
    SuspendPage: <SuspendPage />,
    AccountPage: <AccountPage />
  };

  // const onSwitchWidth = (e, opt) => {
  //   setcurrWidthOption(opt);
  // };
  // const onSwitchBanner = (e, opt) => {
  //   setcurrBannerOption(opt);
  // };

  useEffect(() => {
    screenSize({ view: currWidthOption });
  }, [screenSize, currWidthOption]);

  useEffect(() => {
    const subdomain = window.location.pathname.replace("/ptps/", "");
    let func: any = null;

    switch (subdomain) {
      case "appointment":
        func = {
          FUNC_KEY: "1",
          ICON: null,
          NAME: "appointment",
          LABEL: "Appointment",
          COMPONENT: "Appointment",
          PARENT_UID: null,
          SUB_FUNC: null,
          IS_SHOW: 1,
          BACKFUNCNAME: null,
          PAYLOADONEXIT: null,
        };
        break;
      case "approverPage":
        func = {
          FUNC_KEY: "4",
          ICON: null,
          NAME: "approverPage",
          LABEL: "Approval",
          COMPONENT: "ApproveRequest",
          PARENT_UID: null,
          SUB_FUNC: null,
          IS_SHOW: 1,
          BACKFUNCNAME: null,
          PAYLOADONEXIT: "CLEAR-APPROVE-DATA",
        };
        break;
      case "endorserPage":
        func = {
          FUNC_KEY: "5",
          ICON: null,
          NAME: "endorserPage",
          LABEL: "Endorsement",
          COMPONENT: "EndorserRequest",
          PARENT_UID: null,
          SUB_FUNC: null,
          IS_SHOW: 1,
          BACKFUNCNAME: null,
          PAYLOADONEXIT: "CLEAR-APPROVE-DATA",
        };
        break;
      case "importantNotesPage":
        func = {
          FUNC_KEY: "9",
          ICON: null,
          NAME: "importantNotesPage",
          LABEL: "Important Notes",
          COMPONENT: "ImportantNotesPage",
          PARENT_UID: null,
          SUB_FUNC: null,
          IS_SHOW: 1,
          BACKFUNCNAME: null,
          PAYLOADONEXIT: null,
        };
        break;
      case "suspendPage":
        func = {
          FUNC_KEY: "10",
          ICON: null,
          NAME: "suspendPage",
          LABEL: "Suspend Appointment",
          COMPONENT: "SuspendPage",
          PARENT_UID: null,
          SUB_FUNC: null,
          IS_SHOW: 1,
          BACKFUNCNAME: null,
          PAYLOADONEXIT: null,
        };
        break;
      case "accountPage":
        func = {
          FUNC_KEY: "8",
          ICON: null,
          NAME: "accountPage",
          LABEL: "Bank Account",
          COMPONENT: "AccountPage",
          PARENT_UID: null,
          SUB_FUNC: null,
          IS_SHOW: 1,
          BACKFUNCNAME: null,
          PAYLOADONEXIT: null,
        };
        break;
      default:
        break;
    }

    if (func) {
      navigate(func);
    }
  }, [navigate, component]);

  const mobileIcon = (
    <div className="mTrigger mobile-menu-wrap  d-block d-lg-none">
      <MainMenu
        mode="mobile"
        className="mTrigger mobile-menu-wrap d-block d-lg-none"
      />
    </div>
  );

  const defaultPage = "Part-time Payment System";
  const bannerLabel =
    currPageFunction === undefined || currPageFunction === null
      ? defaultPage
      : currPageFunction.label === undefined
      ? defaultPage
      : label(currPageFunction.label, "i18n");

  let subBannerLabel = "";

  // Banner Subtitle
  switch (component) {
    case "HourlyPage":
    case "MonthlyPage":
    case "LumpSumPage":
      subBannerLabel = "Create / Amend Payment Request";
      break;
    case "ApproveRequest":
      subBannerLabel = "Approve Request";
      break;
    case "EndorserRequest":
      subBannerLabel = "Endorse Request";
      break;
    case "ImportantNotesPage":
      subBannerLabel = "Important Notes";
      break;
    case "AccountPage":
      subBannerLabel = "Bank Account Information";
      break;
    default:
      break;
  }

  const antIcon = <Icon type="LoadingOutlined" style={{ fontSize: 24 }} spin />;
  const banner =
    currBannerOption === "default" ? (
      <Banner
        image="/assets/img/temp/3_banner_givenow.jpg"
        name={bannerLabel}
        funcName={subBannerLabel}
        device={device}
      />
    ) : (
      ""
    );
  return (
    <>
      <Spin
        spinning={loading}
        size="large"
        tip={label("LB0001")}
        indicator={antIcon}
      >
        <Header mobileIcon={mobileIcon} barMenu={<HeaderBar />} />
        <MainMenu mode="horizontal" />
        {banner}
        <main className="page-content" tabIndex={-1}>
          <div className={currWidthOption}>
            <div className="dashboard-ig">
              {/*Main Content Here */}
              {components[component]}
            </div>
          </div>
        </main>
        <Footer />
      </Spin>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    loading: state.dashboard.loadingCount !== 0,
    // configData:       state.initConfig.configData,
    permissions: state?.initConfig?.permissions,
    // action:           state.action.type,
    // result:           state.action.result,
    // currPageFunction: state.dashboard.currPageFunction,
    component: state.dashboard?.currentFunction?.COMPONENT,
    device: state.session.device,
    functions: state.dashboard.functions,
  };
};

const mapDispatchToProps = (dispatch) => ({
  reset: () => {
    dispatch({ type: "RESET-RESULT" });
  },
  navigate: (toFunctions) => {
    dispatch(navigateAction(toFunctions));
  },
  pageNotFound: () => {
    dispatch(routeToPageNotFoundAction());
  },
  screenSize: (device) => {
    dispatch({ type: "SET-DEVICE", payload: device });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PTPS);
